import config from '@/config/index' // 路径配置
import {
    loading
} from '@/common/loading';

import{
    tzloadActionAjax,tzReadActionAjax
}from  '@/api/baseMsg';
export default {
    name: "xiaoxitixing",
    data() {
        return {
            active2: this.$route.query.isPlain==undefined ? 0 : (this.$route.query.isPlain ? 0 : 1),
            type: this.$route.query.type,
            // =========start======by wangry
            isPlain: this.$route.query.isPlain==undefined ? true : Boolean(this.$route.query.isPlain),
            showT1: false,
            showT2: false,
            currentDate: new Date(new Date()-180*24*3600*1000), //开始时间
			currentDate2: new Date(), //结束时间
            startTime: '',
            endTime: '',
            btnFlag: false,
            isLoading: false,
            List: [],
            // messageShow: false,
            // title: '',
            // matter: '',
            ydList:[],//已读列表
            wdList:[],//未读列表
            // issueTime:'',//发布时间
            // CreateName:'',//发布者
            //===========end==========
        }
    },
    created() {
        this.init();
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop);
        this.container = this.$refs.container;
        this.initTime();
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
        init() {
            loading(true);
            this.loadActionAjax();
        },
        //消息 houcc 2021.04.10
        loadActionAjax(){
            let date = new Date(this.currentDate);
            let year = date.getFullYear();
            let month = date.getMonth() + 1; if (month >= 1 && month <= 9) { month = `0${month}` }
            let day = date.getDate();  if (day >= 1 && day <= 9) { day = `0${day}` }
            this.currentDate =  `${year}-${month}-${day}`

            date = new Date(this.currentDate2);
            year = date.getFullYear();
            month = date.getMonth() + 1; if (month >= 1 && month <= 9) { month = `0${month}` }
            day = date.getDate();  if (day >= 1 && day <= 9) { day = `0${day}` }
            this.currentDate2 =  `${year}-${month}-${day}`
           
            tzloadActionAjax({
                pageIndex: 0,
                pageSize: 100,
                createCompId: '',
                titleName: '',
                startTime: this.currentDate+" 00:00:00",
                endTime:  this.currentDate2+" 23:59:59",
              }).then((res) => {
                this.ydList=[];
                this.wdList=[];
                for(let i = 0; i < res.data.length; i++) {
                    if(res.data[i].readStatus==1){//readStatus 为1是已读 readStatus 为0是未读
                        this.ydList.push(res.data[i]);
                    }else{
                        this.wdList.push(res.data[i]);
                    }
                }
                if(this.isPlain){
                    this.List=this.wdList;
                }else{
                    this.List=this.ydList;
                }
                loading(false)
              })
        },
        //去掉style样式
        removeHtmlStyle(html) {
            var rel = /style\s*?=\s*?([‘"])[\s\S]*?\1/;
            if (html) {
                html = html.replace(rel, "").replace(/<\/?.+?>/g,"");
            }
            return html;
          },
        //消息已读
        readActionAjax(id,item,index){
            var getTimestamp = new Date().getTime();//时间戳
            tzReadActionAjax(getTimestamp, {
                id: id,
              }).then((res) => {
                    if(res.code == 200){
                        this.List.splice(index, 1);
                        this.wdList.splice(index, 1);
                        this.ydList.push(item);
                    }
              })
        },
        //置顶图标
        backTop() {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
        scrollToTop() {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            that.btnFlag = that.scrollTop > 130;
            // that.isBarNav = that.scrollTop > 10;
        },
        onRefresh() {
            setTimeout(() => {
                this.isLoading = false;
                this.init();
            }, 300);
        },
        showStartT() {
            this.showT1 = true;
        },
        showEndT() {
            this.showT2 = true;
        },
        confirm() {
            let nowDate = this.currentDate;
            // let date = {
            //     year: nowDate.getFullYear(),
            //     month: nowDate.getMonth() + 1,
            //     date: nowDate.getDate(),
            // }
            // this.startTime = year + '-' + date.month + '-' + date.date;
            let year= nowDate.getFullYear();
            let month = nowDate.getMonth() + 1; if (month >= 1 && month <= 9) { month = `0${month}` }
            let day = nowDate.getDate();  if (day >= 1 && day <= 9) { day = `0${day}` }
            this.startTime =  `${year}-${month}-${day}`
            this.showT1 = false;
        },
        confirm2() {
            let nowDate = this.currentDate2;
            // let date = {
            //     year: nowDate.getFullYear(),
            //     month: nowDate.getMonth() + 1,
            //     date: nowDate.getDate(),
            // }
            // this.endTime = date.year + '-' + date.month + '-' + date.date;
            let year= nowDate.getFullYear();
            let month = nowDate.getMonth() + 1; if (month >= 1 && month <= 9) { month = `0${month}` }
            let day = nowDate.getDate();  if (day >= 1 && day <= 9) { day = `0${day}` }
            this.endTime =  `${year}-${month}-${day}`
            this.showT2 = false;
        },
        cancel() {
            let newMessage5 = this.convertDateFromString(this.startTime)
            this.showT1 = false;
            this.currentDate = newMessage5
        },
        cancel2() {
            let newMessage6 = this.convertDateFromString(this.endTime)
            this.showT2 = false;
            this.currentDate2 = newMessage6
        },
        formatter(type, value) {
            if (type === 'year') {
                return `${value}年`;
            } else if (type === 'month') {
                return `${value}月`
            } else if (type === 'day') {
                return `${value}日`
            }
            return value;
        },
        convertDateFromString(dateString) {
            if (dateString) {
                var date = new Date(dateString.replace(/-/, "/"))
                return date;
            }
        },
        initTime() {
            //初始化显示时间函数
            let sD,
              sM,
              sY,
              eD,
              eM,
              eY = "";
            let today = new Date().getTime();
            eD = new Date().getDate();
            eM = new Date().getMonth() + 1;
            eY = new Date().getFullYear();
            this.endTime = eY + "-" + eM + "-" + eD;
            // sD = new Date(today - 172800000).getDate();
            // sM = new Date(today - 172800000).getMonth() + 1;
            // sY = new Date(today - 172800000).getFullYear();
            sD = new Date(today - 180*24*3600*1000).getDate()
			sM = new Date(today - 180*24*3600*1000).getMonth() + 1
			sY = new Date(today - 180*24*3600*1000).getFullYear()
            this.startTime = sY + "-" + sM + "-" + sD;
            this.currentDate = this.convertDateFromString(this.startTime);
            this.currentDate2 = this.convertDateFromString(this.endTime);
          },
        onClickLeft() {
            this.$router.push({
                path: '/',
            });
        },
        onClickRight() {//一键已读
        
        },
        titleClick() {//title点击事件
            let num = this.active2
            this.List=[{}];
            this.messageShow = false;
            if (num == 0) {//未读
                this.isPlain = true;
                this.List = this.wdList;
            }else if (num == 1) {//已读
                this.isPlain = false;
                this.List = this.ydList;
            }
        },
        search() {
            var startDate = new Date((this.startTime).replace(/-/g, "/")).getTime(); //开始时间
            var endDate = new Date((this.endTime).replace(/-/g, "/")).getTime(); //结束时间
            if (startDate > endDate) {
                this.$dialog.alert({
                    message: '开始时间不可大于结束时间'
                })
                return;
            }
            // 待定
            this.loadActionAjax();
        },
        messageClick(item,index) {//点击消息盒子
            // this.messageShow = true;
            // this.title = item.title;
            // this.issueTime= item.issueTime;//发布时间
            // this.CreateName= item.CreateName;//发布者
            // this.matter = item.content;
            this.$router.push({
                path: '/tongzhixiangqing',
                query: {
                    id: item.id,
                    isPlain:this.isPlain
                }
            })

            // if(this.isPlain){
            //     this.readActionAjax(item.id,item,index);
            // }
        },
        turnoff() {//弹出盒子关闭
            this.messageShow = false;
        }
    },
    watch: {
        $route(newVal, oldVal) {
            this.type = this.$route.query.type;
        },
    }
}